<template>
    <div>
        <div class="filter-sidebar-overlay" :class="{ active: isOpen }" @click="close"></div>
        <div class="filter-sidebar" :class="{ active: isOpen }">
            <div class="filter-sidebar-header">
                <span class="filter-sidebar-title">{{ title }}</span>
                <button type="button" class="filter-sidebar-close" @click="close" aria-label="Close">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>
            </div>
            <div class="filter-sidebar-content">
                <!-- Facetten / Filter -->
                <div v-for="facet in facets" :key="facet.id" class="filter-sidebar-section">
                    <h3 class="filter-sidebar-section-title">{{ facet.name }}</h3>
                    <div class="filter-sidebar-colors">
                        <div
                            v-for="value in facet.values"
                            :key="value.id"
                            class="filter-color-item"
                            :class="{ 'is-selected': isSelected(value.id) }"
                            @click="toggleFacet(value.id)"
                            :title="value.name + ' (' + value.count + ')'"
                        >
                            <span class="filter-color-swatch" :class="'color-' + value.cssClass"></span>
                            <span class="filter-color-name">{{ value.name }}</span>
                            <span class="filter-color-count">({{ value.count }})</span>
                        </div>
                    </div>
                </div>

                <!-- Sortierung -->
                <div class="filter-sidebar-section">
                    <h3 class="filter-sidebar-section-title">{{ sortingTitle }}</h3>
                    <div class="filter-sidebar-sorting">
                        <label
                            v-for="(label, key) in sortingOptions"
                            :key="key"
                            class="filter-sidebar-option"
                        >
                            <input
                                type="radio"
                                name="sorting"
                                :value="key"
                                :checked="key === currentSorting"
                                @change="selectSorting(key)"
                            >
                            <span>{{ label }}</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FilterSidebar",

    props: {
        title: {
            type: String,
            default: "Filtern & Sortieren"
        },
        sortingTitle: {
            type: String,
            default: "Sortierung"
        },
        sortingOptions: {
            type: Object,
            default: () => ({})
        },
        selectedSorting: {
            type: String,
            default: ""
        },
        facets: {
            type: Array,
            default: () => []
        },
        selectedFacets: {
            type: String,
            default: ""
        }
    },

    data() {
        return {
            isOpen: false,
            currentSorting: this.selectedSorting,
            activeFacets: this.parseSelectedFacets(this.selectedFacets)
        };
    },

    watch: {
        selectedSorting(newVal) {
            this.currentSorting = newVal;
        },
        selectedFacets(newVal) {
            this.activeFacets = this.parseSelectedFacets(newVal);
        }
    },

    mounted() {
        window.openFilterSidebar = this.open.bind(this);
        window.closeFilterSidebar = this.close.bind(this);
    },

    beforeDestroy() {
        delete window.openFilterSidebar;
        delete window.closeFilterSidebar;
    },

    methods: {
        open() {
            this.isOpen = true;
            document.body.classList.add('filter-sidebar-open');
        },

        close() {
            this.isOpen = false;
            document.body.classList.remove('filter-sidebar-open');
        },

        selectSorting(key) {
            this.currentSorting = key;
            this.$store.dispatch('selectItemListSorting', key);
            this.close();
        },

        parseSelectedFacets(facetsString) {
            if (!facetsString) return [];
            return facetsString.split(',').map(id => parseInt(id, 10)).filter(id => !isNaN(id));
        },

        isSelected(facetId) {
            return this.activeFacets.includes(facetId);
        },

        toggleFacet(facetId) {
            let newFacets;

            if (this.isSelected(facetId)) {
                // Entfernen
                newFacets = this.activeFacets.filter(id => id !== facetId);
            } else {
                // Hinzufügen
                newFacets = [...this.activeFacets, facetId];
            }

            this.activeFacets = newFacets;
            this.applyFacets(newFacets);
        },

        applyFacets(facetIds) {
            const url = new URL(window.location.href);

            // Page-Parameter entfernen bei Facetten-Änderung
            url.searchParams.delete('page');

            if (facetIds.length > 0) {
                url.searchParams.set('facets', facetIds.join(','));
            } else {
                url.searchParams.delete('facets');
            }

            // Zur neuen URL navigieren
            window.location.href = url.toString();
        }
    }
};
</script>
